import styled from 'styled-components';

export const DocumentsListWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 20px;
`;

export const InfoElement = styled.div`
  display: flex;
  margin-bottom: 14px;
  & > div:first-child {
    margin-right: 8px;
  }
`;
